/*
 * @Description: 就诊系统新接口
 * @Author: huangshiwen
 * @Date: 2022-06-14 09:16:48
 * @LastEditTime: 2022-06-28 13:57:47
 */
import $axios from './axios.js'
const baseUrl ="/v1/webpatient";
export const patientApi = {
  // 发送验证码 
  sendCode(data={}){
    return $axios.post(baseUrl+"/sms/auth/sendCode", data);
  },
  // 获取公钥
  rsaPublic(data={}){
    return $axios.get(baseUrl+"/rsa/public", {
      params: { ...data }
    });
  },
  // 修改密码
  modifyPc(data={}){
    return $axios.post(baseUrl+"/user/modifyPc", data);
  },
  // 手机号验证登录
  loginBySmsCode(data={}){
    return $axios.post(baseUrl+"/user/loginBySmsCode",data);
  },
  // 账号密码登录
  login(data={}){
    return $axios.post(baseUrl+"/user/login",data);
  },
  // 用户注册
  userRegister(data={}){
    return $axios.post(baseUrl+"/user/register",data);
  },
  // 就诊人列表
  patientList(data={}){
    return $axios.get(baseUrl+"/patient/list", {
      params: { ...data }
    });
  },
  // 添加就诊人
  addPatient(data={}){
    return $axios.post(baseUrl+"/patient/add",data);
  },
   // 删除就诊人
   patientDel(data={}){
    return $axios.get(baseUrl+"/patient/del", {
      params: { ...data }
    });
  },
   // 挂号科室列表
   deptList(data={}){
    return $axios.get(baseUrl+"/dept/list", {
      params: { ...data }
    });
  },
   //出诊医生列表
   dutyList(data={}){
    return $axios.get(baseUrl+"/duty/list", {
      params: { ...data }
    });
  },
   //分时段排班-成都+苏州
   getDutyDoctorDetail(data={}){
    return $axios.get(baseUrl+"/duty/doctor/detail", {
      params: { ...data }
    });
  },
  //预约
  addBook(data={}){
    return $axios.post(baseUrl+"/book/add",data);
  },
  //预约列表
  bookList(data={}){
    return $axios.get(baseUrl+"/book/list", {
      params: { ...data }
    });
  },
  //预约详情
  bookDetail(data={}){
    return $axios.get(baseUrl+"/book/detail", {
      params: { ...data }
    });
  },
  //取消预约
  bookCancel(data={}){
    return $axios.get(baseUrl+"/book/cancel", {
      params: { ...data }
    });
  },
  //退号
  bookRefund(data={}){
    return $axios.post(baseUrl+"/book/refund",data);
  },
  //苏州0元挂号
  szZeroBook(data={}){
    return $axios.post(baseUrl+"/book/zero/register",data);
  },
  //合肥获取会员权益列表
  getVipList(data={}){
    return $axios.get(baseUrl+"xxxxxxxx", {
      params: { ...data }
    });
  },
  //合肥获取我的优惠券列表
  getCardList(data={}){
    return $axios.get(baseUrl+"/counp/list", {
      params: { ...data }
    });
  },
  //出诊医生
  getDutyList(data={}){
    return $axios.get(baseUrl+"/duty/list", {
      params: { ...data }
    });
  },
  // 合肥-分时段排班
  dutyDoctor(data={}){
    return $axios.get(baseUrl+"/duty/doctor", {
      params: { ...data }
    });
  },
  // 体检记录详情
  getExamBookDetail(data={}){
    return $axios.get(baseUrl+"/medical/exam/book/detail", {
      params: { ...data }
    });
  },
  // 合肥日清单列表
  getDailyList(data={}){
    return $axios.get(baseUrl+"/inpatient/bill/list", {
      params: { ...data }
    });
  },
  // 卡券激活
  getCardActive(data={}){
    return $axios.get(baseUrl+"/counp/active", {
      params: { ...data }
    });
  },
  // 卡券校验
  getCardCheck(data={}){
    return $axios.get(baseUrl+"/counp/check", {
      params: { ...data }
    });
  },
  // 体检套餐详情
  getMedicalExamDetail(data={}){
    return $axios.get(baseUrl+"/medical/exam/detail", {
      params: { ...data }
    });
  },
  // 体检套餐预约
  getMedicalExamBook(data={}){
    return $axios.post(baseUrl+"/medical/exam/book",data);
  },
  // 查询体检套餐排班日
  getExamDate(data={}){
    return $axios.get(baseUrl+"/medical/exam/date", {
      params: { ...data }
    });
  },
  // 合肥体检套餐分时段排班
  getDayPart(data={}){
    return $axios.get(baseUrl+"/medical/exam/time", {
      params: { ...data }
    });
  },
  // 市场活动-签到
  marketSign(data={}){
    return $axios.get(baseUrl+"/market/sign", {
      params: { ...data }
    });
  },
  // 市场活动-报名
  marketApply(data={}){
    return $axios.get(baseUrl+"/market/apply", {
      params: { ...data }
    });
  },
  // 成都苏州获取可预约日期
  getExamDutyDate(data={}){
    return $axios.get(baseUrl+"/medical/exam/duty/date", {
      params: { ...data }
    });
  },
  // 苏州获取体检发票
  getExamInvoiceList(data={}){
    return $axios.get(baseUrl+"/invoice/pay/list", {
      params: { ...data }
    });
  },
  //苏州团体体检信息查询
  getBookDetail(data={}){
    return $axios.get(baseUrl+"/medical/exam/group/info", {
      params: { ...data }
    });
  },
  //苏州团体体检时间日期
  getExamDutyDate(data={}){
    return $axios.get(baseUrl+"/medical/exam/duty/date", {
      params: { ...data }
    });
  },
  //苏州团体体检提交
  modifyExamGroupInfo(data={}){
    return $axios.get(baseUrl+"/medical/exam/group/modify", {
      params: { ...data }
    });
  },
  // 成都医师出诊信息
  getDutyDoctorvisit(data={}){
    return $axios.get(baseUrl+"/duty/doctor/visit", {
      params: { ...data }
    });
  }
}